<template>
  <v-card class="py-1">
    <v-card-title class="py-0">
      <div class="subheading font-weight-medium mr-2">Filters</div>
      <v-btn :disabled="!hasFilter" small color="info" outline class="border-secondary" @click="clearFilters()">
        <span class="text-capitalize">{{ $t("Button.Clear_Filters") }}</span>
      </v-btn>
    </v-card-title>
    <transition-group name="list">
      <v-card-text v-for="filterType in filterTypes" :key="filterType.key" row grow class="filter-type-layout mb-2 py-0">
        <v-layout v-if="filterType.filters.length > 0">
          <v-flex style="flex: 0 0 150px;">
            <div class="body-1 text-xs-right" style="line-height: 32px;">{{ filterType.label }}:</div>
          </v-flex>
          <v-flex class="pl-2">
            <v-chip close small v-for="filter in filterType.filters" :key="filter.id" @input="removeFilter(filter.id)">
              {{ filter }}
            </v-chip>
          </v-flex>
        </v-layout>
      </v-card-text>
    </transition-group>
  </v-card>
</template>

<script>
  import {
    createNamespacedHelpers,
  } from 'vuex'

  import {
    filterTypes,
  } from '@/store/datasetfilter'

  const datasetfilter = createNamespacedHelpers('datasetfilter')

  export default {
    props: {
      hasFilter: Boolean,
    },
    computed: {
      ...datasetfilter.mapGetters(['getFilter', 'getFilterId']),
      nonEmptyFilterTypes() {
        return filterTypes.filter(f => this.getFilter(f.key).length > 0)
      },
      filterTypes() {
        return this.nonEmptyFilterTypes.map(({
          key,
          label,
        }) => ({
          key,
          label,
          filters: this.getFilter(key).map((filter, index) => ({
            ...filter,
            toString: () => filter.toString(),
            id: this.getFilterId(key, index),
          })),
        }))
      },
    },
    methods: {
      ...datasetfilter.mapMutations({
        removeFilter: 'RemoveFilter',
      }),
      clearFilters() {
        this.$emit('clearFilters')
      },
      makeFilter() {

      },
    },
  }
</script>

<style scoped>
  div.filter-type-layout {
    width: 100%;
  }

  div.filter-type-tile>>>div.v-list__tile {
    height: auto;
    max-height: 100px;
  }

  .list-enter-active,
  .list-leave-active {
    transition: all 1s;
  }

  .list-enter,
  .list-leave-to

  /* .list-leave-active below version 2.1.8 */
    {
    opacity: 0;
    transform: translateY(30px);
  }
</style>